/**
 * Session flag for Mario client-preview UI.
 * When active, mutating apiFetch calls send X-Platzona-Client-Preview so the
 * backend clamps structure/settings/publish for that request only.
 * Does not change auth tokens or Membership — opt-in header, never elevates.
 */

export const CLIENT_PREVIEW_HEADER = 'X-Platzona-Client-Preview';

let clientPreviewRequestActive = false;

export function setClientPreviewRequestActive(active: boolean): void {
  clientPreviewRequestActive = Boolean(active);
}

export function isClientPreviewRequestActive(): boolean {
  return clientPreviewRequestActive;
}

/** Headers to attach on mutating requests while preview overlay is active. */
export function clientPreviewMutatingHeaders(): Record<string, string> {
  return clientPreviewRequestActive ? { [CLIENT_PREVIEW_HEADER]: '1' } : {};
}

export function isMutatingHttpMethod(method?: string): boolean {
  const m = (method || 'GET').toUpperCase();
  return m !== 'GET' && m !== 'HEAD' && m !== 'OPTIONS';
}
